import { getRequest } from '../services/requestHandler';
import { PutterType } from '../models';

export const getPutterTypes = async () => {
  const url = 'putter/getPutterTypes?activeOnly=true&useCache=false';
  const response = await getRequest<PutterType>('GetPutterTypes', url);
  return response;
};
